/**
 * @generated SignedSource<<8f3e30c3546b9fdd5215ca1baaf202e9>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ByLine_content$data = {
  readonly contentProperties: {
    readonly latest: {
      readonly generatedBy: string | null;
    } | null;
  } | null;
  readonly editorProperty: {
    readonly nodes: ReadonlyArray<{
      readonly id: string | null;
      readonly key: string | null;
      readonly value: string | null;
    } | null> | null;
  } | null;
  readonly history: {
    readonly createdBy: {
      readonly accountId?: string | null;
      readonly displayName: string | null;
      readonly profilePicture: {
        readonly path: string;
      } | null;
      readonly type: string | null;
    } | null;
    readonly createdDate: string | null;
    readonly lastOwnedBy: {
      readonly accountId?: string | null;
      readonly displayName: string | null;
      readonly profilePicture: {
        readonly path: string;
      } | null;
      readonly type: string | null;
    } | null;
    readonly ownedBy: {
      readonly accountId?: string | null;
      readonly displayName: string | null;
      readonly profilePicture: {
        readonly path: string;
      } | null;
      readonly type: string | null;
    } | null;
  } | null;
  readonly id: string | null;
  readonly metadata: {
    readonly frontend: {
      readonly coverPictureWidth?: string | null;
    } | null;
  };
  readonly pageTitlePublished?: {
    readonly nodes: ReadonlyArray<{
      readonly id: string | null;
      readonly key: string | null;
      readonly value: string | null;
      readonly version: {
        readonly number: number | null;
      } | null;
    } | null> | null;
  } | null;
  readonly subType: string | null;
  readonly type: string | null;
  readonly version: {
    readonly by: {
      readonly accountId?: string | null;
      readonly displayName: string | null;
      readonly profilePicture: {
        readonly path: string;
      } | null;
      readonly type: string | null;
    } | null;
    readonly contentTypeModified: boolean | null;
    readonly friendlyWhen: string | null;
    readonly number: number | null;
    readonly when: string | null;
  } | null;
  readonly " $fragmentType": "ByLine_content";
};
export type ByLine_content$key = {
  readonly " $data"?: ByLine_content$data;
  readonly " $fragmentSpreads": FragmentRefs<"ByLine_content">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "kind": "ScalarField",
  "name": "id"
},
v1 = {
  "kind": "ScalarField",
  "name": "type"
},
v2 = [
  (v1/*: any*/),
  {
    "kind": "ScalarField",
    "name": "displayName"
  },
  {
    "kind": "InlineFragment",
    "selections": [
      {
        "kind": "ScalarField",
        "name": "accountId"
      }
    ],
    "type": "KnownUser"
  },
  {
    "concreteType": "Icon",
    "kind": "LinkedField",
    "name": "profilePicture",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "path"
      }
    ]
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "number"
},
v4 = {
  "kind": "ScalarField",
  "name": "key"
},
v5 = {
  "kind": "ScalarField",
  "name": "value"
};
return {
  "argumentDefinitions": [
    {
      "defaultValue": false,
      "kind": "LocalArgument",
      "name": "useNewContentTopper"
    }
  ],
  "kind": "Fragment",
  "name": "ByLine_content",
  "selections": [
    (v0/*: any*/),
    (v1/*: any*/),
    {
      "kind": "ScalarField",
      "name": "subType"
    },
    {
      "concreteType": "History",
      "kind": "LinkedField",
      "name": "history",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "createdDate"
        },
        {
          "kind": "LinkedField",
          "name": "createdBy",
          "plural": false,
          "selections": (v2/*: any*/)
        },
        {
          "kind": "LinkedField",
          "name": "ownedBy",
          "plural": false,
          "selections": (v2/*: any*/)
        },
        {
          "kind": "LinkedField",
          "name": "lastOwnedBy",
          "plural": false,
          "selections": (v2/*: any*/)
        }
      ]
    },
    {
      "concreteType": "Version",
      "kind": "LinkedField",
      "name": "version",
      "plural": false,
      "selections": [
        {
          "kind": "LinkedField",
          "name": "by",
          "plural": false,
          "selections": (v2/*: any*/)
        },
        {
          "kind": "ScalarField",
          "name": "friendlyWhen"
        },
        {
          "kind": "ScalarField",
          "name": "when"
        },
        (v3/*: any*/),
        {
          "kind": "ScalarField",
          "name": "contentTypeModified"
        }
      ]
    },
    {
      "concreteType": "ContentProperties",
      "kind": "LinkedField",
      "name": "contentProperties",
      "plural": false,
      "selections": [
        {
          "concreteType": "PublishedContentProperties",
          "kind": "LinkedField",
          "name": "latest",
          "plural": false,
          "selections": [
            {
              "kind": "ScalarField",
              "name": "generatedBy"
            }
          ]
        }
      ]
    },
    {
      "condition": "useNewContentTopper",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": "pageTitlePublished",
          "args": [
            {
              "kind": "Literal",
              "name": "key",
              "value": "page-title-property-published"
            }
          ],
          "concreteType": "PaginatedJsonContentPropertyList",
          "kind": "LinkedField",
          "name": "properties",
          "plural": false,
          "selections": [
            {
              "concreteType": "JsonContentProperty",
              "kind": "LinkedField",
              "name": "nodes",
              "plural": true,
              "selections": [
                (v0/*: any*/),
                (v4/*: any*/),
                (v5/*: any*/),
                {
                  "concreteType": "Version",
                  "kind": "LinkedField",
                  "name": "version",
                  "plural": false,
                  "selections": [
                    (v3/*: any*/)
                  ]
                }
              ]
            }
          ],
          "storageKey": "properties(key:\"page-title-property-published\")"
        }
      ]
    },
    {
      "alias": "editorProperty",
      "args": [
        {
          "kind": "Literal",
          "name": "key",
          "value": "editor"
        }
      ],
      "concreteType": "PaginatedJsonContentPropertyList",
      "kind": "LinkedField",
      "name": "properties",
      "plural": false,
      "selections": [
        {
          "concreteType": "JsonContentProperty",
          "kind": "LinkedField",
          "name": "nodes",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            (v4/*: any*/),
            (v5/*: any*/)
          ]
        }
      ],
      "storageKey": "properties(key:\"editor\")"
    },
    {
      "concreteType": "ContentMetadata",
      "kind": "LinkedField",
      "name": "metadata",
      "plural": false,
      "selections": [
        {
          "concreteType": "ContentMetadata_SpaFriendlyMetadataProvider_frontend",
          "kind": "LinkedField",
          "name": "frontend",
          "plural": false,
          "selections": [
            {
              "condition": "useNewContentTopper",
              "kind": "Condition",
              "passingValue": true,
              "selections": [
                {
                  "kind": "ScalarField",
                  "name": "coverPictureWidth"
                }
              ]
            }
          ]
        }
      ]
    }
  ],
  "type": "Content"
};
})();

(node as any).hash = "c5794442c1aa5969c7a468bc7d59f254";

export default node;
